// 扩展物品数据库
import { Item } from './ItemSystem.js';

export const EXTENDED_ITEMS: Item[] = [
  // ========== 更多食物 ==========
  {
    id: 'steamed_bun',
    name: '馒头',
    description: '松软的白面馒头。',
    category: 'consumable',
    rarity: 'common',
    icon: '🥟',
    effects: [
      { type: 'restore', target: 'stamina', value: 30 }
    ],
    stackable: true,
    maxStack: 99,
    sellPrice: 8,
    buyPrice: 15,
    consumable: true,
  },
  {
    id: 'noodles',
    name: '面条',
    description: '热腾腾的汤面。',
    category: 'consumable',
    rarity: 'common',
    icon: '🍜',
    effects: [
      { type: 'restore', target: 'stamina', value: 40 }
    ],
    stackable: true,
    maxStack: 99,
    sellPrice: 15,
    buyPrice: 30,
    consumable: true,
  },
  {
    id: 'meat_bun',
    name: '肉包',
    description: '香喷喷的肉包子。',
    category: 'consumable',
    rarity: 'uncommon',
    icon: '🥟',
    effects: [
      { type: 'restore', target: 'stamina', value: 50 },
      { type: 'heal', target: 'hp', value: 20 }
    ],
    stackable: true,
    maxStack: 50,
    sellPrice: 25,
    buyPrice: 50,
    consumable: true,
  },
  {
    id: 'braised_pork',
    name: '红烧肉',
    description: '肥而不腻的红烧肉，奶奶的手艺。',
    category: 'consumable',
    rarity: 'rare',
    icon: '🍖',
    effects: [
      { type: 'restore', target: 'stamina', value: 80 },
      { type: 'buff', target: 'constitution', value: 10, duration: 3600 }
    ],
    stackable: true,
    maxStack: 20,
    sellPrice: 80,
    buyPrice: 150,
    consumable: true,
  },
  {
    id: 'fish_stew',
    name: '鱼汤',
    description: '鲜美的鱼汤，营养丰富。',
    category: 'consumable',
    rarity: 'uncommon',
    icon: '🥘',
    effects: [
      { type: 'heal', target: 'hp', value: 60 },
      { type: 'restore', target: 'stamina', value: 30 }
    ],
    stackable: true,
    maxStack: 20,
    sellPrice: 40,
    buyPrice: 80,
    consumable: true,
  },
  
  // ========== 更多药品 ==========
  {
    id: 'health_potion_large',
    name: '大补丸',
    description: '珍贵的丹药，可以大量恢复生命。',
    category: 'consumable',
    rarity: 'rare',
    icon: '💊',
    effects: [
      { type: 'heal', target: 'hp', value: 100 }
    ],
    stackable: true,
    maxStack: 50,
    sellPrice: 50,
    buyPrice: 100,
    consumable: true,
  },
  {
    id: 'stamina_potion_large',
    name: '精力丹',
    description: '恢复大量体力的丹药。',
    category: 'consumable',
    rarity: 'rare',
    icon: '💊',
    effects: [
      { type: 'restore', target: 'stamina', value: 100 }
    ],
    stackable: true,
    maxStack: 50,
    sellPrice: 40,
    buyPrice: 80,
    consumable: true,
  },
  {
    id: 'happiness_potion',
    name: '开心果',
    description: '让人心情变好的神奇果实。',
    category: 'consumable',
    rarity: 'epic',
    icon: '🍄',
    effects: [
      { type: 'buff', target: 'happiness', value: 50, duration: 7200 }
    ],
    stackable: true,
    maxStack: 10,
    sellPrice: 200,
    buyPrice: 500,
    consumable: true,
  },
  {
    id: 'wisdom_potion',
    name: '智慧果',
    description: '传说吃了会变聪明的果实。',
    category: 'consumable',
    rarity: 'epic',
    icon: '🍎',
    effects: [
      { type: 'buff', target: 'wisdom', value: 20, duration: 3600 }
    ],
    stackable: true,
    maxStack: 10,
    sellPrice: 300,
    buyPrice: 600,
    consumable: true,
  },
  
  // ========== 更多装备 ==========
  {
    id: 'bamboo_hat',
    name: '斗笠',
    description: '遮风挡雨的竹编斗笠。',
    category: 'equipment',
    rarity: 'common',
    icon: '👒',
    equipmentSlot: 'head',
    stats: { defense: 2, charm: 1 },
    stackable: false,
    maxStack: 1,
    sellPrice: 20,
    buyPrice: 40,
  },
  {
    id: 'linen_robe',
    name: '麻布衣',
    description: '普通村民穿的麻布衣服。',
    category: 'equipment',
    rarity: 'common',
    icon: '👘',
    equipmentSlot: 'body',
    stats: { defense: 3, charm: 1 },
    stackable: false,
    maxStack: 1,
    sellPrice: 40,
    buyPrice: 80,
  },
  {
    id: 'fur_coat',
    name: '皮袄',
    description: '保暖的皮衣，适合冬天穿。',
    category: 'equipment',
    rarity: 'uncommon',
    icon: '🧥',
    equipmentSlot: 'body',
    stats: { defense: 8, charm: 3 },
    stackable: false,
    maxStack: 1,
    sellPrice: 150,
    buyPrice: 300,
  },
  {
    id: 'silk_dress',
    name: '绸缎衣',
    description: '精致的绸缎衣服，看起来很贵气。',
    category: 'equipment',
    rarity: 'rare',
    icon: '👗',
    equipmentSlot: 'body',
    stats: { defense: 5, charm: 15 },
    stackable: false,
    maxStack: 1,
    sellPrice: 500,
    buyPrice: 1000,
  },
  {
    id: 'bronze_sword',
    name: '青铜剑',
    description: '比铁剑更锋利的武器。',
    category: 'equipment',
    rarity: 'uncommon',
    icon: '⚔️',
    equipmentSlot: 'weapon',
    stats: { attack: 25 },
    stackable: false,
    maxStack: 1,
    sellPrice: 200,
    buyPrice: 400,
  },
  {
    id: 'steel_sword',
    name: '精钢剑',
    description: '用上好钢材打造的剑。',
    category: 'equipment',
    rarity: 'rare',
    icon: '🗡️',
    equipmentSlot: 'weapon',
    stats: { attack: 40 },
    stackable: false,
    maxStack: 1,
    sellPrice: 800,
    buyPrice: 1500,
  },
  {
    id: 'legendary_sword',
    name: '放牛剑',
    description: '传说中的神剑，据说只有真正的放牛山守护者才能使用。',
    category: 'equipment',
    rarity: 'legendary',
    icon: '⚔️',
    equipmentSlot: 'weapon',
    stats: { attack: 100, charm: 20, wisdom: 20 },
    stackable: false,
    maxStack: 1,
    sellPrice: 10000,
    buyPrice: 0,
  },
  {
    id: 'silver_ring',
    name: '银戒指',
    description: '普通的银戒指。',
    category: 'equipment',
    rarity: 'uncommon',
    icon: '💍',
    equipmentSlot: 'accessory',
    stats: { charm: 5 },
    stackable: false,
    maxStack: 1,
    sellPrice: 100,
    buyPrice: 200,
  },
  {
    id: 'gold_ring',
    name: '金戒指',
    description: '贵重的金戒指。',
    category: 'equipment',
    rarity: 'rare',
    icon: '💍',
    equipmentSlot: 'accessory',
    stats: { charm: 10 },
    stackable: false,
    maxStack: 1,
    sellPrice: 500,
    buyPrice: 1000,
  },
  {
    id: 'ruby_necklace',
    name: '红宝石项链',
    description: '镶嵌着红宝石的精美项链。',
    category: 'equipment',
    rarity: 'epic',
    icon: '📿',
    equipmentSlot: 'accessory',
    stats: { charm: 25, wisdom: 10 },
    stackable: false,
    maxStack: 1,
    sellPrice: 2000,
    buyPrice: 4000,
  },
  
  // ========== 更多材料 ==========
  {
    id: 'bamboo',
    name: '竹子',
    description: '山里常见的竹子。',
    category: 'material',
    rarity: 'common',
    icon: '🎋',
    stackable: true,
    maxStack: 999,
    sellPrice: 3,
    buyPrice: 6,
  },
  {
    id: 'clay',
    name: '黏土',
    description: '可以用来制作陶器。',
    category: 'material',
    rarity: 'common',
    icon: '🟫',
    stackable: true,
    maxStack: 999,
    sellPrice: 2,
    buyPrice: 4,
  },
  {
    id: 'silk',
    name: '丝绸',
    description: '珍贵的丝织品。',
    category: 'material',
    rarity: 'rare',
    icon: '🧵',
    stackable: true,
    maxStack: 999,
    sellPrice: 50,
    buyPrice: 100,
  },
  {
    id: 'leather',
    name: '皮革',
    description: '动物皮革，可以制作防具。',
    category: 'material',
    rarity: 'uncommon',
    icon: '🟫',
    stackable: true,
    maxStack: 999,
    sellPrice: 20,
    buyPrice: 40,
  },
  {
    id: 'feather',
    name: '羽毛',
    description: '鸟类的羽毛。',
    category: 'material',
    rarity: 'common',
    icon: '🪶',
    stackable: true,
    maxStack: 999,
    sellPrice: 5,
    buyPrice: 10,
  },
  {
    id: 'pearl',
    name: '珍珠',
    description: '河蚌里找到的珍珠。',
    category: 'material',
    rarity: 'rare',
    icon: '⚪',
    stackable: true,
    maxStack: 99,
    sellPrice: 100,
    buyPrice: 200,
  },
  {
    id: 'jade',
    name: '玉石',
    description: '价值不菲的玉石。',
    category: 'material',
    rarity: 'epic',
    icon: '💎',
    stackable: true,
    maxStack: 99,
    sellPrice: 500,
    buyPrice: 1000,
  },
  {
    id: 'diamond',
    name: '钻石',
    description: '极其珍贵的宝石。',
    category: 'material',
    rarity: 'legendary',
    icon: '💎',
    stackable: true,
    maxStack: 10,
    sellPrice: 2000,
    buyPrice: 5000,
  },
  {
    id: 'mushroom',
    name: '蘑菇',
    description: '山里采的蘑菇，有些可以食用。',
    category: 'material',
    rarity: 'common',
    icon: '🍄',
    stackable: true,
    maxStack: 99,
    sellPrice: 5,
    buyPrice: 10,
  },
  {
    id: 'berries',
    name: '野果',
    description: '山里随处可见的野果。',
    category: 'material',
    rarity: 'common',
    icon: '🫐',
    stackable: true,
    maxStack: 99,
    sellPrice: 3,
    buyPrice: 6,
  },
  
  // ========== 收集品 ==========
  {
    id: 'insect_wing',
    name: '昆虫翅膀',
    description: '漂亮的蝴蝶翅膀。',
    category: 'collectible',
    rarity: 'common',
    icon: '🦋',
    stackable: true,
    maxStack: 20,
    sellPrice: 10,
    buyPrice: 0,
  },
  {
    id: 'snake_skin',
    name: '蛇蜕',
    description: '蛇蜕下的皮，据说可以入药。',
    category: 'collectible',
    rarity: 'uncommon',
    icon: '🐍',
    stackable: true,
    maxStack: 10,
    sellPrice: 30,
    buyPrice: 0,
  },
  {
    id: 'ancient_coin',
    name: '古钱币',
    description: '年代久远的铜钱。',
    category: 'collectible',
    rarity: 'rare',
    icon: '🪙',
    stackable: true,
    maxStack: 50,
    sellPrice: 100,
    buyPrice: 0,
  },
  {
    id: 'fossil',
    name: '化石',
    description: '远古生物的化石。',
    category: 'collectible',
    rarity: 'epic',
    icon: '🦴',
    stackable: true,
    maxStack: 5,
    sellPrice: 500,
    buyPrice: 0,
  },
  {
    id: 'meteorite',
    name: '陨石',
    description: '从天而降的陨石碎片。',
    category: 'collectible',
    rarity: 'legendary',
    icon: '☄️',
    stackable: true,
    maxStack: 3,
    sellPrice: 2000,
    buyPrice: 0,
  },
  {
    id: 'dried_flower',
    name: '干花',
    description: '精心保存的干花。',
    category: 'collectible',
    rarity: 'common',
    icon: '🌸',
    stackable: true,
    maxStack: 20,
    sellPrice: 5,
    buyPrice: 0,
  },
  {
    id: 'leaf_bookmark',
    name: '叶脉书签',
    description: '用树叶制成的精美书签。',
    category: 'collectible',
    rarity: 'uncommon',
    icon: '🍃',
    stackable: true,
    maxStack: 10,
    sellPrice: 15,
    buyPrice: 0,
  },
  
  // ========== 特殊物品 ==========
  {
    id: 'bait',
    name: '鱼饵',
    description: '钓鱼用的饵料。',
    category: 'consumable',
    rarity: 'common',
    icon: '🪱',
    stackable: true,
    maxStack: 99,
    sellPrice: 2,
    buyPrice: 5,
    consumable: true,
  },
  {
    id: 'fishing_rod',
    name: '鱼竿',
    description: '普通的钓鱼竿。',
    category: 'equipment',
    rarity: 'common',
    icon: '🎣',
    equipmentSlot: 'weapon',
    stats: { attack: 1 },
    stackable: false,
    maxStack: 1,
    sellPrice: 50,
    buyPrice: 100,
  },
  {
    id: 'fishing_rod_master',
    name: '大师鱼竿',
    description: '顶级钓鱼竿，传说只有钓鱼大师才能使用。',
    category: 'equipment',
    rarity: 'epic',
    icon: '🎣',
    equipmentSlot: 'weapon',
    stats: { attack: 5, wisdom: 10 },
    stackable: false,
    maxStack: 1,
    sellPrice: 2000,
    buyPrice: 0,
  },
  {
    id: 'axe',
    name: '斧头',
    description: '用来砍伐树木的工具。',
    category: 'equipment',
    rarity: 'common',
    icon: '🪓',
    equipmentSlot: 'weapon',
    stats: { attack: 8 },
    stackable: false,
    maxStack: 1,
    sellPrice: 80,
    buyPrice: 160,
  },
  {
    id: 'pickaxe',
    name: '矿镐',
    description: '用来挖矿的工具。',
    category: 'equipment',
    rarity: 'common',
    icon: '⛏️',
    equipmentSlot: 'weapon',
    stats: { attack: 6 },
    stackable: false,
    maxStack: 1,
    sellPrice: 100,
    buyPrice: 200,
  },
  {
    id: 'hoe',
    name: '锄头',
    description: '用来耕地的农具。',
    category: 'equipment',
    rarity: 'common',
    icon: '🔨',
    equipmentSlot: 'weapon',
    stats: { attack: 4 },
    stackable: false,
    maxStack: 1,
    sellPrice: 60,
    buyPrice: 120,
  },
  {
    id: 'camera',
    name: '相机',
    description: '记录美好瞬间的相机。',
    category: 'equipment',
    rarity: 'rare',
    icon: '📷',
    equipmentSlot: 'accessory',
    stats: { charm: 5 },
    stackable: false,
    maxStack: 1,
    sellPrice: 1000,
    buyPrice: 2000,
  },
  {
    id: 'book',
    name: '书籍',
    description: '增长知识的书籍。',
    category: 'consumable',
    rarity: 'uncommon',
    icon: '📚',
    effects: [
      { type: 'buff', target: 'wisdom', value: 2, duration: 0 }
    ],
    stackable: true,
    maxStack: 10,
    sellPrice: 50,
    buyPrice: 100,
    consumable: true,
  },
  {
    id: 'diary',
    name: '日记本',
    description: '记录每天心情的日记本。',
    category: 'collectible',
    rarity: 'uncommon',
    icon: '📔',
    stackable: false,
    maxStack: 1,
    sellPrice: 0,
    buyPrice: 50,
  },
  {
    id: 'treasure_map_fragment',
    name: '藏宝图碎片',
    description: '藏宝图的一部分，收集完整就能找到宝藏。',
    category: 'quest',
    rarity: 'epic',
    icon: '🗺️',
    questItem: true,
    stackable: true,
    maxStack: 5,
    sellPrice: 100,
    buyPrice: 0,
  },
  {
    id: 'ancient_gold',
    name: '古代金币',
    description: '古代的金币，价值连城。',
    category: 'collectible',
    rarity: 'legendary',
    icon: '🪙',
    stackable: true,
    maxStack: 99,
    sellPrice: 500,
    buyPrice: 0,
  },
  {
    id: 'ghost_lantern',
    name: '魂灯',
    description: '幽灵留下的灯笼，据说能照亮阴阳两界。',
    category: 'collectible',
    rarity: 'legendary',
    icon: '🏮',
    stackable: false,
    maxStack: 1,
    sellPrice: 2000,
    buyPrice: 0,
  },
  {
    id: 'boar_meat',
    name: '野猪肉',
    description: '狩猎获得的野猪肉，味道鲜美。',
    category: 'consumable',
    rarity: 'uncommon',
    icon: '🥓',
    effects: [
      { type: 'restore', target: 'stamina', value: 60 }
    ],
    stackable: true,
    maxStack: 20,
    sellPrice: 30,
    buyPrice: 60,
    consumable: true,
  },
  {
    id: 'legendary_fish',
    name: '龙鱼',
    description: '传说中的鱼，据说吃了可以延年益寿。',
    category: 'collectible',
    rarity: 'legendary',
    icon: '🐉',
    stackable: true,
    maxStack: 1,
    sellPrice: 1000,
    buyPrice: 0,
  },

  // ========== 成就奖励物品 ==========
  {
    id: 'grandma_photo',
    name: '全家福照片',
    description: '和奶奶的珍贵合影，记录着美好的回忆。',
    category: 'collectible',
    rarity: 'epic',
    icon: '📷',
    stackable: false,
    maxStack: 1,
    sellPrice: 500,
    buyPrice: 0,
  },
  {
    id: 'golden_trophy',
    name: '金杯',
    description: '授予完成所有任务的勇士。',
    category: 'collectible',
    rarity: 'legendary',
    icon: '🏆',
    stackable: false,
    maxStack: 1,
    sellPrice: 5000,
    buyPrice: 0,
  },
  {
    id: 'memory_album',
    name: '时光相册',
    description: '记录着一年来点点滴滴的相册。',
    category: 'collectible',
    rarity: 'mythic',
    icon: '📖',
    stackable: false,
    maxStack: 1,
    sellPrice: 10000,
    buyPrice: 0,
  },

  // ========== 特殊家具 ==========
  {
    id: 'kang_table',
    name: '炕桌',
    description: '农村常见的炕桌。',
    category: 'furniture',
    rarity: 'common',
    icon: '🪑',
    stackable: false,
    maxStack: 1,
    sellPrice: 50,
    buyPrice: 100,
  },
  {
    id: 'clay_oven',
    name: '土灶',
    description: '传统的土灶。',
    category: 'furniture',
    rarity: 'common',
    icon: '🍳',
    stackable: false,
    maxStack: 1,
    sellPrice: 80,
    buyPrice: 150,
  },
  {
    id: 'bamboo_cabinet',
    name: '竹柜',
    description: '用竹子编成的柜子。',
    category: 'furniture',
    rarity: 'common',
    icon: '🗄️',
    stackable: false,
    maxStack: 1,
    sellPrice: 60,
    buyPrice: 120,
  },
  {
    id: 'wooden_chest',
    name: '木箱',
    description: '坚固的木箱。',
    category: 'furniture',
    rarity: 'uncommon',
    icon: '📦',
    stackable: false,
    maxStack: 1,
    sellPrice: 100,
    buyPrice: 200,
  },
  {
    id: 'incense_burner',
    name: '香炉',
    description: '古朴的香炉。',
    category: 'furniture',
    rarity: 'rare',
    icon: '🕯️',
    stackable: false,
    maxStack: 1,
    sellPrice: 200,
    buyPrice: 400,
  },
  {
    id: 'paper_cutting',
    name: '剪纸',
    description: '精美的窗花剪纸。',
    category: 'furniture',
    rarity: 'common',
    icon: '✂️',
    stackable: true,
    maxStack: 10,
    sellPrice: 20,
    buyPrice: 40,
  },
  {
    id: 'new_year_poster',
    name: '年画',
    description: '喜庆的年画。',
    category: 'furniture',
    rarity: 'common',
    icon: '🧧',
    stackable: true,
    maxStack: 10,
    sellPrice: 25,
    buyPrice: 50,
  },
  {
    id: 'lantern_red',
    name: '红灯笼',
    description: '喜庆的大红灯笼。',
    category: 'furniture',
    rarity: 'uncommon',
    icon: '🏮',
    stackable: true,
    maxStack: 10,
    sellPrice: 40,
    buyPrice: 80,
  },
  {
    id: 'bamboo_flute',
    name: '竹笛',
    description: '精致的竹笛。',
    category: 'equipment',
    rarity: 'uncommon',
    icon: '🎵',
    equipmentSlot: 'accessory',
    stats: { charm: 15, wisdom: 5 },
    stackable: false,
    maxStack: 1,
    sellPrice: 100,
    buyPrice: 200,
  },
  {
    id: 'tea_set',
    name: '茶具',
    description: '精致的茶具。',
    category: 'furniture',
    rarity: 'rare',
    icon: '🍵',
    stackable: false,
    maxStack: 1,
    sellPrice: 150,
    buyPrice: 300,
  },
  {
    id: 'fish_tank',
    name: '鱼缸',
    description: '漂亮的鱼缸。',
    category: 'furniture',
    rarity: 'rare',
    icon: '🐠',
    stackable: false,
    maxStack: 1,
    sellPrice: 180,
    buyPrice: 350,
  },
  {
    id: 'bird_cage',
    name: '鸟笼',
    description: '精致的竹编鸟笼。',
    category: 'furniture',
    rarity: 'uncommon',
    icon: '🛖',
    stackable: false,
    maxStack: 1,
    sellPrice: 80,
    buyPrice: 160,
  },
  {
    id: 'wind_chime',
    name: '风铃',
    description: '清脆的风铃。',
    category: 'furniture',
    rarity: 'uncommon',
    icon: '🔔',
    stackable: false,
    maxStack: 1,
    sellPrice: 60,
    buyPrice: 120,
  },

  // ========== 特殊材料 ==========
  {
    id: 'moonlight_stone',
    name: '月光石',
    description: '在月光下会发光的石头。',
    category: 'material',
    rarity: 'rare',
    icon: '💫',
    stackable: true,
    maxStack: 99,
    sellPrice: 100,
    buyPrice: 200,
  },
  {
    id: 'spring_water',
    name: '泉水',
    description: '甘甜的泉水。',
    category: 'material',
    rarity: 'uncommon',
    icon: '💦',
    stackable: true,
    maxStack: 20,
    sellPrice: 30,
    buyPrice: 60,
  },
  {
    id: 'jade_cup',
    name: '玉杯',
    description: '精美的玉杯。',
    category: 'collectible',
    rarity: 'epic',
    icon: '🍶',
    stackable: false,
    maxStack: 1,
    sellPrice: 800,
    buyPrice: 0,
  },
  {
    id: 'silver_bracelet',
    name: '银手镯',
    description: '精致的银手镯。',
    category: 'collectible',
    rarity: 'rare',
    icon: '💍',
    stackable: false,
    maxStack: 1,
    sellPrice: 300,
    buyPrice: 0,
  },
  {
    id: 'brocade_pouch',
    name: '锦囊',
    description: '绣有精美图案的锦囊。',
    category: 'material',
    rarity: 'uncommon',
    icon: '👜',
    stackable: true,
    maxStack: 10,
    sellPrice: 40,
    buyPrice: 80,
  },

  // ========== 特殊消耗品 ==========
  {
    id: 'blessing_charm',
    name: '护身符',
    description: '可以抵挡一次厄运。',
    category: 'consumable',
    rarity: 'rare',
    icon: '🧿',
    effects: [{ type: 'special', target: 'happiness', value: 20 }],
    stackable: true,
    maxStack: 5,
    sellPrice: 100,
    buyPrice: 200,
    consumable: true,
  },
  {
    id: 'time_crystal',
    name: '时间晶石',
    description: '神秘的晶石。',
    category: 'consumable',
    rarity: 'epic',
    icon: '💎',
    effects: [{ type: 'special', target: 'stamina', value: 100 }],
    stackable: true,
    maxStack: 10,
    sellPrice: 300,
    buyPrice: 600,
    consumable: true,
  },
  {
    id: 'rainbow_feather',
    name: '彩虹羽',
    description: '传说中神鸟的羽毛。',
    category: 'collectible',
    rarity: 'epic',
    icon: '🪶',
    stackable: true,
    maxStack: 5,
    sellPrice: 400,
    buyPrice: 800,
  },
  {
    id: 'firefly_jar',
    name: '萤火虫罐',
    description: '夜晚会发光的萤火虫罐。',
    category: 'collectible',
    rarity: 'rare',
    icon: '✨',
    stackable: true,
    maxStack: 10,
    sellPrice: 150,
    buyPrice: 0,
  },

  // ========== 更多装备 ==========
  {
    id: 'straw_hat',
    name: '草帽',
    description: '夏天防晒的好帮手。',
    category: 'equipment',
    rarity: 'common',
    icon: '👒',
    equipmentSlot: 'head',
    stats: { defense: 2, charm: 3 },
    stackable: false,
    maxStack: 1,
    sellPrice: 20,
    buyPrice: 40,
  },
  {
    id: 'rain_coat',
    name: '蓑衣',
    description: '用稻草编成的雨具。',
    category: 'equipment',
    rarity: 'common',
    icon: '🧥',
    equipmentSlot: 'body',
    stats: { defense: 5 },
    stackable: false,
    maxStack: 1,
    sellPrice: 30,
    buyPrice: 60,
  },
  {
    id: 'cloth_shoes',
    name: '布鞋',
    description: '舒适的布鞋。',
    category: 'equipment',
    rarity: 'common',
    icon: '👟',
    equipmentSlot: 'feet',
    stats: { speed: 3 },
    stackable: false,
    maxStack: 1,
    sellPrice: 25,
    buyPrice: 50,
  },
  {
    id: 'bamboo_staff',
    name: '竹杖',
    description: '老人常用的拐杖。',
    category: 'equipment',
    rarity: 'common',
    icon: '🦯',
    equipmentSlot: 'weapon',
    stats: { attack: 5 },
    stackable: false,
    maxStack: 1,
    sellPrice: 15,
    buyPrice: 30,
  },

  // ========== 农作物种子 ==========
  {
    id: 'corn_seed',
    name: '玉米种子',
    description: '玉米的种子。',
    category: 'material',
    rarity: 'common',
    icon: '🌽',
    stackable: true,
    maxStack: 99,
    sellPrice: 5,
    buyPrice: 10,
  },
  {
    id: 'wheat_seed',
    name: '小麦种子',
    description: '小麦的种子。',
    category: 'material',
    rarity: 'common',
    icon: '🌾',
    stackable: true,
    maxStack: 99,
    sellPrice: 5,
    buyPrice: 10,
  },
  {
    id: 'rice_seed',
    name: '水稻种子',
    description: '水稻的种子。',
    category: 'material',
    rarity: 'common',
    icon: '🍚',
    stackable: true,
    maxStack: 99,
    sellPrice: 8,
    buyPrice: 15,
  },
  {
    id: 'tomato_seed',
    name: '番茄种子',
    description: '番茄的种子。',
    category: 'material',
    rarity: 'common',
    icon: '🍅',
    stackable: true,
    maxStack: 99,
    sellPrice: 6,
    buyPrice: 12,
  },
  {
    id: 'cabbage_seed',
    name: '白菜种子',
    description: '白菜的种子。',
    category: 'material',
    rarity: 'common',
    icon: '🥬',
    stackable: true,
    maxStack: 99,
    sellPrice: 5,
    buyPrice: 10,
  },

  // ========== 农作物收获 ==========
  {
    id: 'corn_harvest',
    name: '玉米',
    description: '成熟的玉米。',
    category: 'material',
    rarity: 'common',
    icon: '🌽',
    stackable: true,
    maxStack: 99,
    sellPrice: 15,
    buyPrice: 30,
  },
  {
    id: 'wheat_harvest',
    name: '小麦',
    description: '收获的小麦。',
    category: 'material',
    rarity: 'common',
    icon: '🌾',
    stackable: true,
    maxStack: 99,
    sellPrice: 12,
    buyPrice: 25,
  },
  {
    id: 'rice_harvest',
    name: '稻谷',
    description: '收获的稻谷。',
    category: 'material',
    rarity: 'common',
    icon: '🍚',
    stackable: true,
    maxStack: 99,
    sellPrice: 18,
    buyPrice: 35,
  },
  {
    id: 'tomato_harvest',
    name: '番茄',
    description: '红彤彤的番茄。',
    category: 'material',
    rarity: 'common',
    icon: '🍅',
    stackable: true,
    maxStack: 99,
    sellPrice: 10,
    buyPrice: 20,
  },
  {
    id: 'cabbage_harvest',
    name: '白菜',
    description: '新鲜的白菜。',
    category: 'material',
    rarity: 'common',
    icon: '🥬',
    stackable: true,
    maxStack: 99,
    sellPrice: 8,
    buyPrice: 15,
  },

  // ========== 更多鱼类 ==========
  {
    id: 'grass_carp',
    name: '草鱼',
    description: '常见的淡水鱼。',
    category: 'material',
    rarity: 'common',
    icon: '🐟',
    stackable: true,
    maxStack: 20,
    sellPrice: 20,
    buyPrice: 40,
  },
  {
    id: 'fish_carp',
    name: '鲤鱼',
    description: '寓意吉祥的鲤鱼。',
    category: 'material',
    rarity: 'uncommon',
    icon: '🐟',
    stackable: true,
    maxStack: 20,
    sellPrice: 35,
    buyPrice: 70,
  },
  {
    id: 'catfish',
    name: '鲶鱼',
    description: '肉质鲜美的鲶鱼。',
    category: 'material',
    rarity: 'uncommon',
    icon: '🐟',
    stackable: true,
    maxStack: 15,
    sellPrice: 40,
    buyPrice: 80,
  },
  {
    id: 'eel',
    name: '黄鳝',
    description: '细长的黄鳝。',
    category: 'material',
    rarity: 'rare',
    icon: '🐍',
    stackable: true,
    maxStack: 10,
    sellPrice: 60,
    buyPrice: 120,
  },

  // ========== 任务物品 ==========
  {
    id: 'red_envelope',
    name: '红包',
    description: '过年时长辈给的红包。',
    category: 'quest',
    rarity: 'rare',
    icon: '🧧',
    stackable: true,
    maxStack: 10,
    sellPrice: 100,
    buyPrice: 0,
  },
  {
    id: 'firecracker',
    name: '鞭炮',
    description: '过年放的鞭炮。',
    category: 'quest',
    rarity: 'common',
    icon: '🧨',
    stackable: true,
    maxStack: 50,
    sellPrice: 10,
    buyPrice: 20,
  },
  {
    id: 'dumpling_wrapper',
    name: '饺子皮',
    description: '包饺子用的皮。',
    category: 'material',
    rarity: 'common',
    icon: '🥟',
    stackable: true,
    maxStack: 99,
    sellPrice: 8,
    buyPrice: 15,
  },
  {
    id: 'meat_filling',
    name: '肉馅',
    description: '调好的饺子馅。',
    category: 'material',
    rarity: 'common',
    icon: '🥩',
    stackable: true,
    maxStack: 50,
    sellPrice: 15,
    buyPrice: 30,
  },
  {
    id: 'lantern_paper',
    name: '灯笼纸',
    description: '糊灯笼用的彩色纸。',
    category: 'material',
    rarity: 'common',
    icon: '📄',
    stackable: true,
    maxStack: 99,
    sellPrice: 5,
    buyPrice: 10,
  },
  {
    id: 'bamboo_strip',
    name: '竹篾',
    description: '编织用品用的竹条。',
    category: 'material',
    rarity: 'common',
    icon: '🎋',
    stackable: true,
    maxStack: 99,
    sellPrice: 3,
    buyPrice: 6,
  },
  
];

// 导出所有扩展物品
export default EXTENDED_ITEMS;
